<template>
  <div>
    <div v-if="item">

      <h4 v-if="item.request">Входные данные</h4>
      <code>  {{item.request}} </code>

      <hr />

      <h4  v-if="item.response">Ответ</h4>
    <code> {{item.response}}  </code>
    </div>
  </div>

</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {

  data: () => ({
    cardLink: "logs",
    cardSetLink: "logs",
    item: null,
    fields: [

    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
